module.exports = __webpack_public_path__ + "img/step_seven.fd691e67.png";